import React from "react";
import { FaChevronLeft, FaChevronRight, FaEllipsisH } from "react-icons/fa";

const Pagination = ({
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  itemsPerPage = 10,
  totalItems = 0,
  showInfo = true,
  disabled = false,
}) => {
  // Sayfa numaralarını hesapla
  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      // Tüm sayfaları göster
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Akıllı sayfa numarası gösterimi
      if (currentPage <= 3) {
        // İlk sayfalar
        for (let i = 1; i <= 4; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        // Son sayfalar
        pages.push(1);
        pages.push("...");
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        // Orta sayfalar
        pages.push(1);
        pages.push("...");
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(totalPages);
      }
    }

    return pages;
  };

  const pageNumbers = getPageNumbers();
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  if (totalPages <= 1) return null;

  return (
    <div className={`flex items-center justify-center sm:justify-between gap-3 sm:gap-4 px-4 sm:px-6 py-3 sm:py-4 bg-white transition-opacity duration-200 ${disabled ? "opacity-50 pointer-events-none" : ""}`}>
      {/* Bilgi - mobilde gizle */}
      {showInfo && (
        <div className="hidden sm:block text-base text-gray-700">
          <span className="font-medium">{startItem}</span> -{" "}
          <span className="font-medium">{endItem}</span> arası, toplam{" "}
          <span className="font-medium">{totalItems}</span> kayıt
        </div>
      )}

      {/* Pagination Controls - daha büyük butonlar */}
      <div className="flex items-center gap-1.5 sm:gap-2">
        {/* İlk Sayfa */}
        <button
          onClick={() => onPageChange(1)}
          disabled={disabled || currentPage === 1}
          className={`flex items-center justify-center w-10 h-10 sm:w-11 sm:h-10 sm:px-3 sm:py-2.5 text-base font-medium rounded-lg transition-all duration-200 ${
            disabled || currentPage === 1
              ? "text-gray-300 cursor-not-allowed"
              : "text-gray-600 hover:bg-gray-100"
          }`}
        >
          <span className="text-lg">«</span>
        </button>

        {/* Önceki Sayfa */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={disabled || currentPage === 1}
          className={`flex items-center justify-center w-10 h-10 sm:w-11 sm:h-10 sm:px-3 sm:py-2.5 text-base font-medium rounded-lg transition-all duration-200 ${
            disabled || currentPage === 1
              ? "text-gray-300 cursor-not-allowed"
              : "text-gray-600 hover:bg-gray-100"
          }`}
        >
          <FaChevronLeft className="w-4 h-4" />
        </button>

        {/* Sayfa Numaraları */}
        <div className="flex items-center gap-1.5">
          {pageNumbers.map((page, index) => (
            <React.Fragment key={index}>
              {page === "..." ? (
                <span className="px-2.5 py-2 text-gray-400">
                  <FaEllipsisH className="w-4 h-4" />
                </span>
              ) : (
                <button
                  onClick={() => onPageChange(page)}
                  disabled={disabled}
                  className={`min-w-[40px] h-10 sm:min-w-[44px] sm:h-10 px-2.5 sm:px-3 py-2 text-base font-semibold rounded-lg transition-all duration-200 ${
                    currentPage === page
                      ? "bg-blue-600 text-white shadow-sm"
                      : disabled
                        ? "text-gray-400 cursor-not-allowed"
                        : "text-gray-700 hover:bg-gray-100"
                  }`}
                >
                  {page}
                </button>
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Sonraki Sayfa */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={disabled || currentPage === totalPages}
          className={`flex items-center justify-center w-10 h-10 sm:w-11 sm:h-10 sm:px-3 sm:py-2.5 text-base font-medium rounded-lg transition-all duration-200 ${
            disabled || currentPage === totalPages
              ? "text-gray-300 cursor-not-allowed"
              : "text-gray-600 hover:bg-gray-100"
          }`}
        >
          <FaChevronRight className="w-4 h-4" />
        </button>

        {/* Son Sayfa */}
        <button
          onClick={() => onPageChange(totalPages)}
          disabled={disabled || currentPage === totalPages}
          className={`flex items-center justify-center w-10 h-10 sm:w-11 sm:h-10 sm:px-3 sm:py-2.5 text-base font-medium rounded-lg transition-all duration-200 ${
            disabled || currentPage === totalPages
              ? "text-gray-300 cursor-not-allowed"
              : "text-gray-600 hover:bg-gray-100"
          }`}
        >
          <span className="text-lg">»</span>
        </button>
      </div>
    </div>
  );
};

export default Pagination;
